import { z } from 'zod/v4';
import { configureZodErrors } from '@backend/schemas/zodConfig';

/**
 * Fallback messages for checks that carry no message of their own, mostly the `.max(n)` that
 * drizzle-zod derives from a column length. Zod's default reads "Too big: expected string to
 * have <=32 characters"; this reads "Must be at most 32 characters". A message written on the
 * check itself always wins.
 *
 * @param issue - The raw issue zod is about to report
 * @returns The fallback message, or undefined to keep zod's default
 */
export function fallbackMessage(issue: { code?: string; origin?: string; maximum?: unknown }): string | undefined {
  if (issue.code === 'too_big' && issue.origin === 'string')
    return `Must be at most ${String(issue.maximum)} characters`;

  return undefined;
}

/**
 * Install `fallbackMessage` on both zod instances the app runs: its own, and the backend's,
 * which every backend-derived schema uses. Call once at startup.
 */
export function installZodErrorMessages(): void {
  z.config({ customError: fallbackMessage });
  configureZodErrors(fallbackMessage);
}
